import { cn } from '@/lib/cn';
import { haptic } from '@/lib/telegram';
import { useUIStore } from '@/store/uiStore';
import type { NavId, ScreenId } from '@/types';

const navItems: Array<{
  id: NavId;
  screen: ScreenId;
  label: string;
  iconSrc: string;
}> = [
  {
    id: 'world',
    screen: 'main',
    label: 'Главная',
    iconSrc: '/data/interface/main.webp',
  },
  {
    id: 'waifus',
    screen: 'waifus',
    label: 'Вайфу',
    iconSrc: '/data/interface/waifu.webp',
  },
  {
    id: 'journal',
    screen: 'journal',
    label: 'Журнал',
    iconSrc: '/data/interface/journal.webp',
  },
  {
    id: 'player-menu',
    screen: 'player-menu',
    label: 'Меню',
    iconSrc: '/data/interface/playermenu.webp',
  },
  {
    id: 'achievements',
    screen: 'achievements',
    label: 'Награды',
    iconSrc: '/data/interface/achievements.webp',
  },
  {
    id: 'settings',
    screen: 'settings',
    label: 'Настройки',
    iconSrc: '/data/interface/settings.webp',
  },
];

export function BottomNav() {
  const activeNav = useUIStore((s) => s.activeNav);
  const setScreen = useUIStore((s) => s.setScreen);

  return (
    <nav
      className="relative z-30 glass border-t border-white/5 shrink-0"
      style={{
        paddingBottom:
          'max(env(safe-area-inset-bottom, 0px), var(--tg-safe-area-bottom, 0px))',
      }}
    >
      <div className="grid grid-cols-6">
        {navItems.map((item) => {
          const active = activeNav === item.id;
          return (
            <button
              key={item.id}
              onTouchStart={() => haptic('light')}
              onClick={() => setScreen(item.screen)}
              className={cn(
                'flex items-center justify-center px-1 py-2 min-h-[60px] transition relative',
                active ? 'text-accent' : 'text-white/55 hover:text-white/80',
              )}
              aria-current={active ? 'page' : undefined}
              aria-label={item.label}
              title={item.label}
            >
              <img
                src={item.iconSrc}
                alt={item.label}
                className={cn(
                  'w-11 h-11 object-contain transition-[filter,transform]',
                )}
                style={{ filter: active ? 'brightness(1.15)' : 'brightness(0.85)' }}
                draggable={false}
              />
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-accent rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
